import React, { useEffect, useState } from "react";
import { Heading } from "../../../CommonComponent/heading";
import { SelectField } from "../../../CommonComponent/SelectField";
import { useSelector } from "react-redux";
import useLocalStorageData from "../../Comman/LocalStorageData";
import useSessionRedirect from "../../Comman/SessionChange";
import { ExamsAPI } from "../../../../api/Examination/Exam";
import EmptyListMessage from "../../../CommonComponent/EmptyListMessage";
import { ExportButton } from "../../../CommonComponent/ReusableButton";
import Swal from "sweetalert2";
import Loader from "../../../Loader/Loader";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { markEntryAPI } from "../../../../api/Examination/MarkEntry";
import ErrorDisplay from "../../../CommonComponent/ErrorDisplay";
const ResultReport = () => {
  const { school_id, token, school_emp_id } = useLocalStorageData();
  const session_id = useSessionRedirect();
  const { allClass } = useSelector((state) => state.getClass);
  const [selectClass, setSelectClass] = useState(null);
  const [resultReportList, setResultReportList] = useState([]);
  const [loading ,setLoading] = useState(false)
  const { classsectionList } = useSelector((state) => state.attendance);
  const [classWiseExamList, setClassWiseExamList] = useState([]);
  const [StudentList, setStudentList] = useState([]);
// copy code from grade card
let classListOption = classsectionList?.payload?.map((c) => ({
  label: `${c.class_name} ${c.section}`,
  value: c.id,
}));
const formik = useFormik({
  enableReinitialize: true,
  initialValues: {
    academic_id: session_id,
    school_id: school_id,
    insert_by: school_emp_id,
    exam_id: null,
    section_id: null,
    student_data: [],
    min: null,
    max: null,
    selectedRange: null, // 👈 Add this
  },
  validationSchema: Yup.object().shape({
    section_id: Yup.string().required("Class is required."),
    exam_id: Yup.string().required("Exam is required."),
  }),
  onSubmit: async (values) => {
    setLoading(true);
    try {
      let body = {
        school_id: school_id,
        academic_id: session_id,
        section_id: values.section_id,
        exam_id: values.exam_id,
      };
      try {
        let response = await ExamsAPI.getStudentResultReport(body);
        let responseData = response.data;
        if (responseData.status === 200) {
          setResultReportList(responseData.report_list);
        }
      } catch (error) {
        console.error(error);
      }finally{
        setLoading(false)
      }
    
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false)
    }
  },
});


useEffect(() => {
  if (formik.values.section_id) {
    fetchExamClassWise();
  }
}, [formik.values.section_id]);
const handleSelectSection = (selectedOptions) => {
  formik.setFieldValue("section_id", selectedOptions?.value || "");
  setStudentList([]);
  setClassWiseExamList([]);
  formik.setFieldValue("exam_id", null);
};

const fetchExamClassWise = async () => {
  try {
    let body = {
      school_id: school_id,
      academic_id: session_id,
      section_id: formik.values.section_id,
    };
    let response = await markEntryAPI.getClassWiseExamsList(body);
    let responseData = response.data;
    if (responseData.status === 200) {
      let list = responseData?.exam_list2?.map((c) => ({
        label: `${c.exam_name1} `,
        value: c.exam_id1,
      }));
      setClassWiseExamList(list);
    }
  } catch (error) {
    console.error(error);
  }
};
// copy code from grade card



  const classList = allClass?.payload?.map((list) => {
    return {
      label: list.class_name,
      value: list.id,
    };
  });
  const fetchGroup = async () => {
    if (!selectClass){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Select Class",
      })
      return
    }
    setLoading(true)
   
    let body = {
      school_id: school_id,
      academic_id: session_id,
      class_id: selectClass,
    };
    try {
      let response = await ExamsAPI.getStudentResultReport(body);
      let responseData = response.data;
      if (responseData.status === 200) {
        setResultReportList(responseData.report_list);
      }
    } catch (error) {
      console.error(error);
    }finally{
      setLoading(false)
    }
  };

  // useEffect(() => {
  //   fetchGroup();
  // }, [session_id, school_id, selectClass]);
  if(loading) return <Loader/>

  const handleView = async () => {
    // Trigger form validation and set fields as touched
    formik.setTouched({
      section_id: true,
      exam_id: true
    });

    // If form is valid, submit it
    if (formik.isValid) {
      await formik.submitForm();
    }
  };

  const handleClear = () => {
    formik.resetForm();
    setResultReportList([]);
    setClassWiseExamList([]);
  };



  const exportResultReport =()=>{

  }

  return (
    <>
      <div className="section-body">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Heading pageTitle={"Result Report"}></Heading>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm mx-1"
                onClick={handleView}
              >
                <i className="fa fa-eye px-1"></i>
                View
              </button>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm mx-1"
                onClick={handleClear}
              >
                <i className="fa fa-times px-1"></i>
                Clear
              </button>
              {resultReportList && resultReportList.length > 0 && (
              <ExportButton id="test-table-xls-button" /> )}
            </div>
          </div>
        </div>
      </div>
      <div className="section-body mt-4">
        <div className="container-fluid">
        <div className="card">
              <div className="card-body row">
                <div className="col-lg-6 ">
                  <div className="form-group col-md-12 row">
                    <label className="col-lg-4 col-form-label">
                      Class <span className="text-danger">*</span>
                    </label>
                    <div className="col-lg-8">
                      <Select
                        name="section_id"
                        placeholder="Select  Class"
                        options={classListOption}
                        value={
                          formik.values.section_id
                            ? classListOption?.find(
                                (g) => g.value === formik.values.section_id
                              )
                            : null
                        }
                        onChange={handleSelectSection}
                        onBlur={formik.handleBlur}
                        isSearchable={true}
                      />
                      {formik.touched.section_id && formik.errors.section_id ? (
                        <ErrorDisplay errorMsg={formik.errors.section_id} />
                      ) : null}
                 
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 ">
                  <div className="form-group col-md-12 row">
                    <label className="col-lg-4 col-form-label">
                      Examination <span className="text-danger">*</span>
                    </label>
                    <div className="col-lg-8">
                      <Select
                        name="exam_id"
                        placeholder="Select Exam "
                        options={classWiseExamList}
                        value={
                          formik.values.exam_id
                            ? classWiseExamList?.find(
                                (g) => g.value === formik.values.exam_id
                              )
                            : null
                        }
                        onChange={(selectedOptions) => {
                          formik.setFieldValue(
                            "exam_id",
                            selectedOptions?.value || ""
                          );
                         
                        }}
                        onBlur={formik.handleBlur}
                        isSearchable={true}
                      />
                      {formik.touched.exam_id && formik.errors.exam_id ? (
                        <ErrorDisplay errorMsg={formik.errors.exam_id} />
                      ) : null}
                     
                    </div>
                  </div>
                </div>
              
              </div>
            </div>

          <div className="card">
            <div className="card-body">
              {resultReportList && resultReportList.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm table-hover mb-0 text-nowrap text-center" id="table-to-xls">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Student Code</th>
                        <th>Class</th>
                        <th>Student Name</th>
                        <th>Marks</th>
                        <th>Percentage</th>
                        <th>Rank</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resultReportList?.map(({ section, result }) => (
                        <>
                          <tr className="table-secondary text-success text-left ">
                            <td colSpan={7}>
                              Class : <span className="">{`${section}`}</span>
                            </td>
                          </tr>
                          {result?.map(({ exam_name, result_report }) => (
                            <>
                              <tr className="table-secondary text-success text-left ">
                                <td colSpan={7}>
                                  Exam Name :{" "}
                                  <span className="">{`${exam_name}`}</span>
                                </td>
                              </tr>
                              {result_report?.map((res, stuIndex) => (
                                <tr>
                                  <td>{stuIndex + 1}</td>
                                  <td>{res.student_code}</td>
                                  <td>{res.section}</td>
                                  <td className="text-left">{res.name}</td>
                                  <td>
                                    {res.obtain_marks} / {res.total_maxMarks}{" "}
                                  </td>
                                  <td>{res.percentage} %</td>
                                  <td>{res.student_rank} </td>
                                </tr>
                              ))}
                            </>
                          ))}
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <EmptyListMessage
                  message={"Result Not Available !"}
                  Div="div"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultReport;

